export const ASSETS_URL = 'https://s3.amazonaws.com/tpassets.devicebits.com'



// WEBPACK FOOTER //
// ./src/constants/urls.js